import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {WalkOfShame} from "../../game/WalkOfShame";
import {Layers} from "../../game/view/WalkOfShameLayers";
import {WalkOfShameSound} from "../../game/sound/WalkOfShameSound";

export class ContinueScreen extends PIXI.Container {
    protected _continueButton: ContinueButton;
    protected _continueCallback: () => void;

    constructor(layer: StageLayer) {
        super();
        this.visible = false;

        this._continueButton = new ContinueButton();
        this._continueButton.enable(false);
        this._continueButton.visible = false;
        this._continueButton.resizeButtonToLabelWithMargin(18, 30, 18, 30);
        this._continueButton.addClickCallback(async () => {
            this._continueButton.enable(false);

            if (!WalkOfShame.model.isRestore && !WalkOfShame.model.parsedGameData.brokeTheBank) {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.FS_CONTINUE
                });
            }

            await this.close();
            if (this._continueCallback) {
                this._continueCallback();
            }
        });
        this.addChild(this._continueButton);

        layer.addChild(this);
        this.onResize();
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._continueButton.position.set(360 - (this._continueButton.width * 0.5), 580);
        } else {
            const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 455;
            this._continueButton.position.set(360 - (this._continueButton.width * 0.5), centerBottom);
        }
    }

    public show(onContinueCallBack: () => void): void {
        this._continueCallback = onContinueCallBack;
        this.visible = true;
        this._continueButton.visible = true;
        this._continueButton.enable(true);

        WalkOfShame.blackOverlay.showOverlay(0.01, 0.8, Layers.BLACK_OVERLAY_TOP);
    }

    protected close(): TimelineLite {
        const tl: TimelineLite = new TimelineLite;
        tl.to(this, {duration: 1, alpha: 0});
        tl.add(() => {
            this._continueButton.enable(false);

            WalkOfShame.blackOverlay.hideOverlay(1);
        }, 0);

        tl.add(() => {
            this.visible = false;
            this.alpha = 1;
            this._continueButton.visible = false;
        });

        return tl;
    }
}